module.exports = __webpack_public_path__ + "img/nenuphar.4c236f72.svg";